<template>
  <transition name="fade">
    <div class="loading" v-show="show">
      <img src="~@/assets/imgs/loading/bg.png" class="loading__bg"
        :class="{ hide: hideMove }">
      <div class="loading__cnt" :class="{ hide: hideMove }">
        <div class="loading__cnt__flower swing">
          <!-- 外面一圈 -->
          <img src="~@/assets/imgs/loading/o0.png" class="swingMax loading__cnt__flower__o0" :class="{ flyawayo1: hideMove }">
          <img src="~@/assets/imgs/loading/o1.png" class="swingMax loading__cnt__flower__o1" :class="{ flyawayo2: hideMove }">
          <img src="~@/assets/imgs/loading/o2.png" class="swingMax loading__cnt__flower__o2" :class="{ flyawayo3: hideMove }">
          <img src="~@/assets/imgs/loading/o3.png" class="swingMax loading__cnt__flower__o3" :class="{ flyawayo4: hideMove }">
          <img src="~@/assets/imgs/loading/o4.png" class="swingMax loading__cnt__flower__o4" :class="{ flyawayo5: hideMove }">
          <img src="~@/assets/imgs/loading/o5.png" class="swingMax loading__cnt__flower__o5" :class="{ flyawayo6: hideMove }">
          <img src="~@/assets/imgs/loading/o6.png" class="swingMax loading__cnt__flower__o6" :class="{ flyawayo7: hideMove }">
          <img src="~@/assets/imgs/loading/o7.png" class="swingMax loading__cnt__flower__o7" :class="{ flyawayo8: hideMove }">
          <img src="~@/assets/imgs/loading/o8.png" class="swingMax loading__cnt__flower__o8" :class="{ flyawayo9: hideMove }">
          <img src="~@/assets/imgs/loading/o9.png" class="swingMax loading__cnt__flower__o9" :class="{ flyawayo10: hideMove }">
          <img src="~@/assets/imgs/loading/o10.png" class="swingMax loading__cnt__flower__o10" :class="{ flyawayo11: hideMove }">
          <img src="~@/assets/imgs/loading/o11.png" class="swingMax loading__cnt__flower__o11" :class="{ flyawayo12: hideMove }">
          <img src="~@/assets/imgs/loading/o12.png" class="swingMax loading__cnt__flower__o12" :class="{ flyawayo13: hideMove }">
          <img src="~@/assets/imgs/loading/o13.png" class="swingMax loading__cnt__flower__o13" :class="{ flyawayo14: hideMove }">
          <!-- 里面一圈 -->
          <img src="~@/assets/imgs/loading/i0.png" class="swingMax loading__cnt__flower__i0" :class="{ flyawayi1: hideMove }">
          <img src="~@/assets/imgs/loading/i1.png" class="swingMax loading__cnt__flower__i1" :class="{ flyawayi2: hideMove }">
          <img src="~@/assets/imgs/loading/i2.png" class="swingMax loading__cnt__flower__i2" :class="{ flyawayi3: hideMove }">
          <img src="~@/assets/imgs/loading/i3.png" class="swingMax loading__cnt__flower__i3" :class="{ flyawayi4: hideMove }">
          <img src="~@/assets/imgs/loading/i4.png" class="swingMax loading__cnt__flower__i4" :class="{ flyawayi5: hideMove }">
          <img src="~@/assets/imgs/loading/i5.png" class="swingMax loading__cnt__flower__i5" :class="{ flyawayi6: hideMove }">
          <img src="~@/assets/imgs/loading/i6.png" class="swingMax loading__cnt__flower__i6" :class="{ flyawayi7: hideMove }">
          <img src="~@/assets/imgs/loading/i7.png" class="swingMax loading__cnt__flower__i7" :class="{ flyawayi8: hideMove }">
          <img src="~@/assets/imgs/loading/i8.png" class="swingMax loading__cnt__flower__i8" :class="{ flyawayi9: hideMove }">
          <img src="~@/assets/imgs/loading/i9.png" class="swingMax loading__cnt__flower__i9" :class="{ flyawayi10: hideMove }">
          <img src="~@/assets/imgs/loading/stick.png" class="loading__cnt__flower__stick">
          <img src="~@/assets/imgs/loading/light.png" class="bling loading__cnt__flower__light">
        </div>
        <div class="loading__cnt__text">
          <img src="~@/assets/imgs/loading/text.png" class="bling loading__cnt__text__img">
        </div>
        <div class="loading__cnt__progress" v-html="progressText"></div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'loading',

  props: ['progress'],

  data () {
    return {
      show: true,
      hideMove: false
    }
  },

  computed: {
    progressText () {
      return `${Math.ceil(this.progress)}%`
    }
  },

  methods: {
    hide () {
      this.hideMove = true
      setTimeout(() => {
        this.show = false
        this.$emit('hide')
      }, 6000)
    }
  }
}
</script>

<style lang="scss">
@import '../style/mixin.scss';
@import '../style/color.scss';

.loading {
  @include fullfill;
  @include box;
  z-index: 100;
  pointer-events: none;
  &__bg {
    @include fullfill;
    @include transform-center;
    object-fit: cover;
    &.hide {
      transition: all ease-in 6s;
      opacity: 0;
    }
  }
  &__cnt {
    &.hide {
      transition: all ease 3s;
      transform: translate(-200%, 50%) scale(.8, .8);
    }
    &__flower {
      transform-origin: 0% 100%;
      margin-left: 10.7vw;
      width: 34.6vw;
      height: 42.35vw;
      position: relative;
      img {
        position: absolute;
      }
      &__example {
        top: 0;
        left: 0;
        width: 100%;
        opacity: 0.5;
      }
      &__stick {
        width: 58.1%;
        left: 6%;
        top: 29%;
      }
      &__light {
        width: 98.2%;
        right: 0%;
        top: 0%;
      }
      &__i0 {
        width: 23.39%;
        left: 48%;
        top: 13%;
      }
      &__i1 {
        width: 43.44%;
        left: 41%;
        top: 20%;
      }
      &__i2 {
        width: 38.3%;
        left: 50%;
        top: 28%;
      }
      &__i3 {
        width: 38.82%;
        left: 46%;
        top: 38%;
      }
      &__i4 {
        width: 31.88%;
        left: 45%;
        top: 44%;
      }
      &__i5 {
        width: 24.16%;
        left: 40%;
        top: 40%;
      }
      &__i6 {
        width: 28.28%;
        left: 20%;
        top: 38%;
      }
      &__i7 {
        width: 38.82%;
        left: 14%;
        top: 36%;
      }
      &__i8 {
        width: 37.28%;
        left: 13%;
        top: 23%;
      }
      &__i9 {
        width: 24.68%;
        left: 27%;
        top: 12%;
      }
      &__o0 {
        width: 24.68%;
        left: 37%;
        top: 3%;
      }
      &__o1 {
        width: 33.93%;
        left: 49%;
        top: 8%;
      }
      &__o2 {
        width: 47.3%;
        left: 50%;
        top: 21%;
      }
      &__o3 {
        width: 48.84%;
        left: 50%;
        top: 32%;
      }
      &__o4 {
        width: 44.99%;
        left: 47%;
        top: 41%;
      }
      &__o5 {
        width: 36.25%;
        left: 51%;
        top: 40%;
      }
      &__o6 {
        width: 24.94%;
        left: 50%;
        top: 41%;
      }
      &__o7 {
        width: 25.45%;
        left: 33%;
        top: 40%;
      }
      &__o8 {
        width: 38.56%;
        left: 10%;
        top: 41%;
      }
      &__o9 {
        width: 47.81%;
        left: 2%;
        top: 40%;
      }
      &__o10 {
        width: 48.59%;
        left: 0%;
        top: 29%;
      }
      &__o11 {
        width: 47.04%;
        left: 0%;
        top: 17%;
      }
      &__o12 {
        width: 40.1%;
        left: 12%;
        top: 12%;
      }
      &__o13 {
        width: 35.48%;
        left: 18%;
        top: 4%;
      }
    }
    &__text {
      width: 56vw;
      min-height: 38.3vw;
      margin-top: 7vw;
      &__img {
        display: block;
        width: 100%;
      }
    }
    &__progress {
      transform: translate(0, 0);
      font-size: .16rem;
      text-align: center;
      color: white;
      line-height: .4rem;
      font-weight: bold;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/loading.vue